import { isMobileDevice } from '../device/isMobileDevice';
import { DEFAULT_EMAIL_PROVIDER, EMAIL_PROVIDER_CONFIG } from './consts/email-provider-config';

const DEEP_LINK_FALLBACK_DELAY_MS = 900;

const getEmailDomain = (email: string): string | null => {
  const atIndex = email.indexOf('@');

  if (atIndex === -1) {
    return null;
  }

  const domain = email.slice(atIndex + 1).trim().toLowerCase();

  return domain || null;
};

export const getEmailProviderRedirectUrl = (email: string): string | null => {
  const domain = getEmailDomain(email);

  if (!domain) {
    return null;
  }

  return EMAIL_PROVIDER_CONFIG[domain]?.webUrl ?? DEFAULT_EMAIL_PROVIDER;
};

export const openEmailClient = (email: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  const domain = getEmailDomain(email);
  const providerConfig = domain ? EMAIL_PROVIDER_CONFIG[domain] : null;
  const deepLink = providerConfig?.deepLink ?? '';
  const providerWebUrl = providerConfig?.webUrl ?? DEFAULT_EMAIL_PROVIDER;

  if (deepLink && isMobileDevice()) {
    window.location.href = deepLink;
    window.setTimeout(() => {
      window.open(providerWebUrl, '_blank', 'noopener,noreferrer');
    }, DEEP_LINK_FALLBACK_DELAY_MS);
    return;
  }

  window.open(providerWebUrl, '_blank', 'noopener,noreferrer');
};
